import React from "react";
import { useFormContext } from "react-hook-form";
import { useFeatureFlagEnabled } from "posthog-js/react";

import Stack from "@mui/material/Stack";

import TooltipInfoIcon from "components/TooltipInfoIcon";
import StyledFormBooleanCheckbox from "components/FormInput/FormBooleanCheckbox";

import { AmountTypeEnum } from "api";

import {
  PAYER_NAME_TOKEN,
  ORDER_NUMBER_TOKEN,
  appendToken,
  removeToken,
} from "shared/functions/ibanQrHelpers";
import { featureFlag } from "shared/constants/posthog";

const PaymentPurposeOptions: React.FC = () => {
  const { watch, setValue, trigger } = useFormContext();

  const showDynamicPaymentPurpose = useFeatureFlagEnabled(
    featureFlag.customized_payment_purpose_feature,
  );

  const paymentPurpose = watch("paymentPurpose") ?? "";
  const amountType = watch("amountType");

  const payerNameDisabled = amountType !== AmountTypeEnum.PayerDefined;

  const orderNumberDisabled = amountType !== AmountTypeEnum.PayerDefined;

  const handleTokenChange = (token: string) => (checked: boolean) => {
    if (checked) {
      if (!paymentPurpose.includes(token)) {
        setValue("paymentPurpose", appendToken(paymentPurpose, token));
      }
    } else {
      setValue("paymentPurpose", removeToken(paymentPurpose, token));
      trigger("paymentPurpose");
    }
  };

  if (!showDynamicPaymentPurpose) return null;

  return (
    <>
      <Stack direction="row" alignItems="center">
        <StyledFormBooleanCheckbox
          name="requestPayerFullName"
          label="Запитувати «Ім'я та прізвище» для призначення платежу"
          labelSx={{ mr: 1 }}
          sx={{ mb: 0 }}
          disabled={payerNameDisabled}
          onChange={(_event, checked) =>
            handleTokenChange(PAYER_NAME_TOKEN)(checked)
          }
        />
        <TooltipInfoIcon
          title="Додає обов'язкове поле «Ім'я та прізвище» на сторінці оплати для посилання з вільною сумою. Дані будуть підставлені в призначення платежу."
          color="#393939"
        />
      </Stack>

      <Stack direction="row" alignItems="center">
        <StyledFormBooleanCheckbox
          name="requestOrderNumber"
          label="Запитувати «Номер замовлення» для призначення платежу"
          labelSx={{ mr: 1 }}
          sx={{ mb: 0 }}
          disabled={orderNumberDisabled}
          onChange={(_event, checked) =>
            handleTokenChange(ORDER_NUMBER_TOKEN)(checked)
          }
        />
        <TooltipInfoIcon title="Додає обов'язкове поле «Номер замовлення» на сторінці оплати для посилання з вільною сумою. Дані будуть підставлені в призначення платежу." />
      </Stack>
    </>
  );
};

export default PaymentPurposeOptions;
